import React from 'react';
import { Form } from 'antd';
import { ModalWrapper } from '../wrapperComponents/page';
import FormWrapper from '../formWrapper/page';
import { formatMsg, invoiceActions, timeutil } from '../..';
import { useDispatch } from 'react-redux';
import { notification } from '../../util/notification';

interface RecordPaymentModalProps {
    open: boolean;
    setOpen: any;
    firebase: any;
    record: any;
}

const { addPayment } = invoiceActions

const RecordPaymentModal: React.FC<RecordPaymentModalProps> = ({
    open,
    setOpen,
    firebase,
    record
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const addPaymentFormFields = [
        [{
            label: formatMsg("amountPaid"),
            type: "input",
            name: "amountPaid",
            placeHolder: formatMsg("placeholder.amountPaid"),
            warningMessage: "Please input paid amount!",
            inputType: "number",
            required: true,
            initialValue: record?.pending?.toString()
        }],
        [{
            label: formatMsg("paymentMode"),
            type: "select",
            name: "paymentMode",
            placeHolder: formatMsg("placeholder.paymentMode"),
            warningMessage: "Please select payment mode!",
            inputType: "select",
            required: true,
            multiple: false,
            options: ["Cheque", "Cash", "UPI", "Bank transfer"],
            initialValue: "Cash"
        }],
        [{
            label: formatMsg("paymentDate"),
            type: "date",
            name: "paymentDate",
            placeHolder: formatMsg("placeholder.paymentDate"),
            warningMessage: "Please select payment date!",
            inputType: "string",
            required: true,
            initialValue: timeutil.getInstance()
        }],
        [{
            label: formatMsg("transactionNumber"),
            type: "input",
            name: "transactionNumber",
            placeHolder: formatMsg("placeholder.transactionNumber"),
            warningMessage: "Please input transaction number!",
            inputType: "string",
        }],
        // [{
        //     label: "",
        //     type: "checkBox",
        //     name: "sendEmailToParents",
        //     inputType: "checkBox",
        //     options: formatMsg("sendEmailToParents"),
        //     initialValue: true
        // }],
    ]


    const handleAddPaymentModalOk = async () => {
        try {
            const values = await form.validateFields();
            const amt = Number(values.amountPaid)
            if (!amt || amt < 1 || amt > record.pending) {
                notification("error", formatMsg("error.amountGreaterOrLessThan"))
                return
            }
            const requestPayload = {
                paymentRecords: [{
                    amount: amt,
                    mode: values.paymentMode,
                    referenceNumber: values.transactionNumber,
                    updatedOn: timeutil.getEpoch(timeutil.getInstance()),
                    timestamp: timeutil.getEpoch(values.paymentDate),
                    createdBy: firebase.user.id
                }],
                sendEmail: values.sendEmailToParents
            }
            form.resetFields()
            dispatch(addPayment({ firebase, requestPayload, invoiceId: record.id }))
            setOpen(false);
        } catch (errorInfo) {
        }
    };
    return (
        <ModalWrapper
            title={'Add Payment'}
            open={open}
            onOk={handleAddPaymentModalOk}
            onCancel={() => {
                setOpen(false);
                form.resetFields();
            }}
            okText="Save"
            maskClosable={false}
        >
            <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
            >
                <FormWrapper formFields={addPaymentFormFields} />
            </Form>
        </ModalWrapper>
    );
};

export default RecordPaymentModal; 